/* Open all PDF links in a new window */
document.querySelectorAll('a').forEach((linkElem: Element, index) => {
	if(linkElem.hasAttribute('href') && linkElem.getAttribute('href').endsWith('.pdf')) {
		linkElem.setAttribute('target', '_blank');
	}
});

declare let Rellax: any;


/*Parallax effekt*/
let rellax = new Rellax('.rellax', {
    speed: 2,
    center: true,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false,
  });
  
// Animate
import * as AOS from "aos";


AOS.init({
  // Global settings:
  disable: (
    /bot|crawler|spider|crawling/i.test(navigator.userAgent)
    || window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ),
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 50, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 800, // values from 0 to 3000, with step 50ms
  easing: 'ease-in-out', // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});


/* mailencrypting */
setTimeout(function () {
	let mailElement = document.querySelectorAll('[data-madr1]:not(.madr-done)');

	mailElement.forEach((mail: HTMLElement, index) => {
		const maddr = mail.getAttribute('data-madr1') + '@' + mail.getAttribute('data-madr2') + '.' + mail.getAttribute('data-madr3');
		const linktext = mail.getAttribute('data-linktext') ? mail.getAttribute('data-linktext') : maddr;

		const a = document.createElement('a')
		a.setAttribute('href', `mailto:${maddr}`)
		a.innerHTML = linktext;

		if (mail.parentElement) mail.parentElement.appendChild(a);
		mail.classList.add('madr-done');
		mail.style.display = 'none';
	});
}, 500);

/* Go to top button */
if(document.querySelector('#theme-to-top')) {
	document.querySelector('#theme-to-top').addEventListener('click', (e) => {
		e.preventDefault();
	
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	})
}

/* scrolling behavior (to top button / breadcrumb) */
const navheader = document.querySelector('#theme-page-navigation') as HTMLElement;

window.addEventListener('scroll', function () {
	const bc = document.querySelector('.theme-page-breadcrumb');
	if (bc != null) {
		(bc as HTMLElement).style.top = `${navheader.offsetHeight - 1}px`;

		// Die Position der Breadcrumbs relativ zum Viewport
		const bcPosition = (bc as HTMLElement).getBoundingClientRect().top;

		// Füge Klasse hinzu, wenn Breadcrumbs die obere Position des Viewports erreicht
		if (bcPosition <= navheader.offsetHeight) {
			bc.classList.add('bg-white', 'shadow-sm');
		} else {
			bc.classList.remove('bg-white', 'shadow-sm');
		}
	}

	const toTop = document.querySelector("#theme-to-top");
	if (toTop != null) {
		/* show / hide scroll to top button */
		if (window.scrollY > 200) {
			toTop.classList.add('theme-top-visible');
		} else {
			toTop.classList.remove('theme-top-visible');
		}
	}
}, false);

/* Breadcrumb */
const bc = document.querySelector('.theme-page-breadcrumb');
if(bc){
	const bcALast = document.querySelector('.theme-page-breadcrumb span a:last-child');
	if(bcALast) bcALast.classList.add('last');

	const bcSpanLast = document.querySelector('.theme-page-breadcrumb span:last-child')
	if(bcSpanLast) bcSpanLast.classList.add('last');

	const bcSpanLinkChild = document.querySelector('.theme-page-breadcrumb span .theme-page-breadcrumb-link:nth-last-child(3)');
	if(bcSpanLinkChild) bcSpanLinkChild.classList.add('second-last');

	bc.classList.toggle('theme-page-breadcrumb-shortened', 
		(document.querySelector('.theme-page-breadcrumb-link') != null || document.querySelectorAll('.theme-page-breadcrumb-link').length > 2)
	)
	
	const bcTrigger = document.querySelector('.theme-page-breadcrumb-trigger');
	if(bcTrigger) {
		bcTrigger.addEventListener('click', () => {
			bc.classList.toggle('theme-page-breadcrumb-shortened')
		})
	}
}

const dialogLinks = document.querySelectorAll('a[data-dialog]');
const flyoutWrapper = document.querySelector('.app-flyoutcontent-iframe-wrapper');
const flyoutIframe = flyoutWrapper?.querySelector('iframe');
const flyoutClose = flyoutWrapper?.querySelector('.close');
const flyoutUnderlay = document.querySelector('.app-flyoutcontent-underlay');

dialogLinks.forEach(link =>
  link.addEventListener('click', e => {
    e.preventDefault();
    showDialog(link as HTMLElement);
  })
);

[flyoutClose, flyoutUnderlay].forEach(el => 
  el?.addEventListener('click', e => {
    e.preventDefault();
    hideDialog();
  })
);

function showDialog(link: HTMLElement) {
  const iframeLink = link.getAttribute('href');
  if (iframeLink) {
    flyoutIframe?.setAttribute('src', iframeLink + '?SkinSrc=[G]Skins/sealtech/skeleton');
    toggleDialog(true);
  }
}

function hideDialog() {
  flyoutIframe?.setAttribute('src', '');
  toggleDialog(false);
}

function toggleDialog(isOpen: boolean) {
  flyoutWrapper?.classList.toggle('is-open', isOpen);
  flyoutUnderlay?.classList.toggle('is-visible', isOpen);
  document.body.classList.toggle('disable-scroll', isOpen);
}





